'use strict';
(function () {

  if (!customElements.get('showcase-scroller')) {
    class ShowcaseScroller extends HTMLElement {
      constructor() {
        super();
        this.onResize = this.onResize.bind(this);
        this.container = this.querySelector('.showcase-scroller__inner');
        this.observer = null;
        this.isInView = false;
        this.elementHeight = 0;
      }

      connectedCallback() {
        this.elementHeight = this.getBoundingClientRect().height;
        this.initializeIntersectionObserver();
        window.addEventListener('resize', this.onResize, { passive: true });
      }

      disconnectedCallback() {
        this.cleanup();
      }

      onResize() {
        this.elementHeight = this.getBoundingClientRect().height;
      }

      initializeIntersectionObserver() {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: [0]
        };

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            this.isInView = entry.isIntersecting;
          });
        }, options);

        this.observer.observe(this);
      }

      cleanup() {
        if (this.observer) {
          this.observer.disconnect();
        }
        window.removeEventListener('resize', this.onResize);
      }
    }

    customElements.define('showcase-scroller', ShowcaseScroller);
  }

})();